import * as React from "react";
import { Box, Stack, TextField, TextFieldProps, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { GridColDef, GridRowsProp } from "@mui/x-data-grid-premium";
import CclGenericAccordian from "../../../../../components/common/cclGenericAccordian";
import CclLoadingButton from "../../../../../components/common/cclButtons/cclLoadingButton";
import ReportsDataGridDataGridPanel from "./reportDataGrid";

export interface ReconcileReviewProps {
    sessionId: string;
}

const ReconcileReview: React.FC<ReconcileReviewProps> = (props) => {
    const sessionId = props.sessionId;
    const [payPeriodEndDate, setPayPeriodEndDate] = React.useState<Date | null>(null);
    const [showData, setShowData] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const timeout = (delay: number) => new Promise(res => setTimeout(res, delay));

    const generateReport = async () => {
        setShowData(false);
        setLoading(true);
        await timeout(500);
        setShowData(true);
        setLoading(false);
    }

    const onDateChange = (date: Date | null) => {
        setPayPeriodEndDate(date);
    }

    const searchInputSx = {
        "& .MuiOutlinedInput-input": {
            paddingTop: "8px!important",
            paddingBottom: "8px!important",
        },
        "& .MuiInputLabel-root": {
            marginTop: "-8px!important",
        },
        "& .MuiInputLabel-shrink": {
            marginTop: "auto!important",
        },
        width: .25
    };

    const columns: GridColDef[] = [
        { field: "trainerName", headerName: "Trainer Name", width: 150 },
        { field: "employeeId", headerName: "Employee ID", width: 150 },
        { field: "loc", headerName: "Loc", width: 150 },
        { field: "earningsCode", headerName: "Earnings Code", width: 150 },
        { field: "units", headerName: "Units", width: 150 },
        { field: "fee", headerName: "Fee", width: 150 },
        { field: "eventCode", headerName: "EventCode", width: 150 },
        { field: "hours", headerName: "Hours", width: 150 },
    ];

    const data: GridRowsProp = [];

    return (
        <Box sx={{ width: "100%" }}>
            <CclGenericAccordian
                headingText={"Reconcile Review Report"}
                defaultExpanded
            >
                <Stack sx={{margin: 1, padding: 1 }} spacing={2}>
                    <Stack direction={"row"} spacing={5} sx={{ mx: 2, mt: 2 }}>
                        <Typography sx={{ alignSelf: "center"}} variant="h6">Pay Period End Date</Typography>
                        <DatePicker
                            onChange={onDateChange}
                            value={payPeriodEndDate}
                            renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => {
                                params.fullWidth = false;
                                return (
                                    <TextField
                                        {...params}
                                        sx={searchInputSx}
                                    />
                                );
                            }}
                        />
                        <CclLoadingButton
                            mode={"primary"}
                            sx={{marginLeft: "auto"}}
                            onClick={generateReport}
                            loading={loading}
                        >
                            Generate
                        </CclLoadingButton>
                    </Stack>
                    {showData && (
                        <ReportsDataGridDataGridPanel
                            sessionId={sessionId}
                            columns={columns}
                            data={data}
                        />
                    )}
                </Stack>
            </CclGenericAccordian>
        </Box>
    );
};

export default ReconcileReview;
